module.exports = __webpack_public_path__ + "static/media/geesaa_logo.ba297bed.png";